var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NavigationLayout',{attrs:{"closeCourseButton":true,"menu":true}},[_c('CourseContainer',{attrs:{"curseId":_vm.curseId,"clickRewardContinue":_vm.clickRewardContinue},on:{"refreshPage":_vm.refreshPage,"moduleCompleted":_vm.moduleCompleted}})],1),_vm._v(" "),(_vm.showRewardCard)?_c('RewardCard',{on:{"continue":_vm.rewardContinue}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fd78f97","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Course.vue
// module id = C1cQ
// module chunks = 0